import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { Customers, CustomersDetails } from './customers.types';

export interface ToggleStatusPayload {
  customerId: string;
  status: 'A' | 'B';
}

export interface ResetPasswordPayload {
  customerId: string;
}

const toggleCustomerStatus = (client: AxiosInstance) => async (payload: ToggleStatusPayload) => {
  return (
    await client.post<{ message: string; data: Customers }>(API_ROUTES.UPDATE_CUSTOMER_STATUS, {
      customerId: payload.customerId,
      status: payload.status,
    })
  ).data;
};

const resetPassword = (client: AxiosInstance) => async (payload: ResetPasswordPayload) => {
  return (
    await client.post<{ message: string; data: Customers }>(API_ROUTES.RESET_CUSTOMER_PASSWORD, {
      customerId: payload.customerId,
    })
  ).data;
};

const deleteCustomer = (client: AxiosInstance) => async (customerId: string) => {
  return (
    await client.post<{ message: string; data: Customers }>(API_ROUTES.UPDATE_CUSTOMER_STATUS, {
      customerId,
      status: 'D',
    })
  ).data;
};

const manageCustomer = (client: AxiosInstance) => async (payload: Partial<CustomersDetails>) => {
  return (await client.post<{ message: string; data: CustomersDetails }>(API_ROUTES.MANAGE_CUSTOMER, payload)).data;
};

export const customersMutations = {
  toggleCustomerStatus,
  resetPassword,
  deleteCustomer,
  manageCustomer,
};
